import { Component, OnInit } from '@angular/core';
import { FailureCategory, FailureCodeModel } from '../../../../../go/model/form.model';
import { FormBuilder, Validators } from '@angular/forms';
import { StoreService } from '../../../../../../services/store.service';
import { AttachmentService } from '../../../../../../services/attachment.service';
import { DialogService } from '../../../../../../services/dialog.service';
import { FailureFormBaseComponent } from '../failure-form-base/failure-form-base.component';

@Component({
  selector: 'failure-form-v1',
  templateUrl: './failure-form-v1.component.html',
  styleUrls: ['../failure-form.scss']
})
export class FailureFormV1Component extends FailureFormBaseComponent implements OnInit {
  constructor(
    protected override storeService: StoreService,
    protected override attachmentService: AttachmentService,
    protected override dialogService: DialogService,
    private readonly fb: FormBuilder
  ) {
    super(storeService, attachmentService, dialogService);
  }
  ngOnInit(): void {
    this.buildForm();
    this.fillFormWithData();
  }

  private buildForm() {
    const disabled = this.data.disabled;
    this.form = this.fb.group({
      name: this.fb.control({value: this.getDefectName(), disabled }, {nonNullable: true, validators: [Validators.required]}),
      description: this.fb.control({value: '', disabled }, {nonNullable: true, validators: [Validators.required]}),
      photos: this.fb.control({value: '', disabled }, {nonNullable: true, validators: []}),
      category: this.fb.control({value: null as FailureCategory | null, disabled }, {validators: [Validators.required]}),
      comment: [{value: null as string | null, disabled }],
      failureCodes: this.fb.control({value: null as unknown as string | string[], disabled }, {nonNullable: true, validators: [Validators.required]})
    });
  }

  getCodeLabel() {
    const failureCodes = this.form.value?.failureCodes;
    if (!failureCodes) {
      return '';
    }
    return this.data.failureMultiselect
      ? failureCodes.map((x: FailureCodeModel) => x.code).join(', ')
      : failureCodes.code;
  }

}
